import React, { useState } from "react";

import { Root } from "@radix-ui/react-accordion";

import { FlowVersion, FlowVersionFlowChild } from "src/api/flowTypes";
import { SearchBox } from "src/base-components/SearchBox";
import { FlowVersionCard } from "src/SelectFlowPane/FlowVersionCard";
import {
  FlowVersionFilter,
  VersionStatusFilterValue,
} from "src/SelectFlowPane/FlowVersionFilter";
import { matchesFilter } from "src/utils/flowVersion";
import { useFuseSearch } from "src/utils/useFuseSearch";

type Props = {
  flowId: string;
  flowVersions: FlowVersionFlowChild[];
  selectedVersionId?: string;
  onSelect: (flowVersion: FlowVersion) => void;
};

export const FlowVersionList: React.FC<Props> = ({
  flowVersions,
  flowId,
  onSelect,
  selectedVersionId,
}) => {
  const [filter, setFilter] = useState<VersionStatusFilterValue>("all");
  const [filterTerm, setFilterTerm] = useState("");
  const search = useFuseSearch(
    flowVersions.filter(
      (version) => filter === "all" || matchesFilter(version, filter),
    ),
    { keys: ["name"] },
  );

  return (
    <div className="flex h-full flex-col">
      <Root
        className="flex h-full flex-col gap-y-3"
        defaultValue={[]}
        type="multiple"
      >
        <div className="border-gray-100 border-b pb-2">
          <SearchBox placeholder="Search a version" onChange={setFilterTerm} />
        </div>
        <FlowVersionFilter
          value={filter}
          onChange={(value) => setFilter(value)}
        />

        <ul className="decideScrollbar !overflow-y-scroll -mr-4 flex flex-col gap-y-3">
          {search(filterTerm)
            .sort((a, b) => +new Date(b.updated_at) - +new Date(a.updated_at))
            .map((version) => (
              <FlowVersionCard
                key={version.id}
                flowId={flowId}
                selected={version.id === selectedVersionId}
                version={version}
                onClick={() => onSelect(version)}
              />
            ))}
        </ul>
      </Root>
    </div>
  );
};
